import React from 'react';
import { motion } from 'framer-motion';
import { DonateModule } from './DonateModule';
export function Hero() {
  return <section className="relative min-h-[90vh] flex items-center pt-24 pb-16 overflow-hidden" data-id="element-129" data-mp="ej4n3wauu9ex">
      <div className="absolute inset-0 z-0" data-id="element-130" data-mp="9luxogngtxr3">
        <img src="https://images.unsplash.com/photo-1509316785289-025f5b846b35?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80" alt="Arizona desert landscape" className="w-full h-full object-cover object-center" data-id="element-131" data-mp="9igw3ammlskp" />
        <div className="absolute inset-0 bg-gradient-to-r from-pac-navy/95 via-pac-navy/80 to-pac-navy/40 mix-blend-multiply" data-id="element-132" data-mp="xbfht2vcv11y" />
        <div className="absolute inset-0 bg-pac-navy/40" data-id="element-133" data-mp="s9giq56neqat" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full" data-id="element-134" data-mp="nb6njukxbpp7">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center" data-id="element-135" data-mp="3d1sbr0oqzpup">
          <div className="lg:col-span-7 text-white" data-id="element-136" data-mp="382p5jcx17dl5">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6
          }} data-id="element-137" data-mp="3814aznapvuna">
              <div className="inline-block bg-pac-gold text-pac-navy font-bold px-4 py-1.5 rounded-full text-sm uppercase tracking-wider mb-6" data-id="element-138" data-mp="3o6kh1mlj0k78">
                Built Locally. Stronger Together.
              </div>
              <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl font-bold leading-tight mb-6 drop-shadow-lg" data-id="element-139" data-mp="3e7uw1kyc2jmr">
                Arizona&apos;s Future Is Decided{' '}
                <span className="text-pac-gold" data-id="element-140" data-mp="358zoo5jjz3hv">Closest to Home.</span>
              </h1>
              <p className="text-xl sm:text-2xl text-slate-200 mb-8 max-w-2xl font-light leading-relaxed drop-shadow-md" data-id="element-141" data-mp="2qkdaw89kqjsr">
                Arizona is not one community. It is hundreds. We stand with
                leaders who listen to their neighbors, collaborate across
                sectors, and protect local decision-making.
              </p>
              <div className="flex flex-wrap gap-4" data-id="element-142" data-mp="2ljz5yz39rpyy">
                <a href="#commitments" className="inline-flex bg-transparent border-2 border-white text-white hover:bg-white hover:text-pac-navy px-8 py-4 rounded font-bold uppercase tracking-wider transition-all" data-id="element-143" data-mp="s2b8o0ipgn67">
                  See Our Commitments
                </a>
              </div>
            </motion.div>
          </div>

          <div className="lg:col-span-5" data-id="element-144" data-mp="1b0nmw0oh4n8n">
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} data-id="element-145" data-mp="1b0ds7zshhrwm">
              <DonateModule data-id="element-146" data-mp="11150zep06rdy" />
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}